"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var ProgressBar = /** @class */ (function (_super) {
    tslib_1.__extends(ProgressBar, _super);
    function ProgressBar(props, context) {
        return _super.call(this, props, context) || this;
    }
    ProgressBar.prototype.calculateLinearRatio = function (value) {
        var _a = this.props, min = _a.min, max = _a.max;
        if (value < this.props.min) {
            return 0;
        }
        if (value > this.props.max) {
            return 1;
        }
        return (value - this.props.min) / (this.props.max - this.props.min);
    };
    ProgressBar.prototype.calculateCircleRatio = function (value, circumference) {
        return circumference * (1 - value / 100);
    };
    ProgressBar.prototype.renderCircle = function () {
        var _a;
        var _b = this.props, children = _b.children, className = _b.className, theme = _b.theme, min = _b.min, max = _b.max, value = _b.value, circle = _b.circle, vertical = _b.vertical, animated = _b.animated, orange = _b.orange, green = _b.green, red = _b.red, yellow = _b.yellow, purple = _b.purple, deepPurple = _b.deepPurple, circleSize = _b.circleSize, others = tslib_1.__rest(_b, ["children", "className", "theme", "min", "max", "value", "circle", "vertical", "animated", "orange", "green", "red", "yellow", "purple", "deepPurple", "circleSize"]);
        var classes = classnames_1.default(theme.circle, className, (_a = {},
            _a[theme.animated] = animated,
            _a[theme.orange] = orange,
            _a[theme.green] = green,
            _a[theme.red] = red,
            _a[theme.yellow] = yellow,
            _a[theme.purple] = purple,
            _a[theme.deepPurple] = deepPurple,
            _a));
        var strokeWidth = 8;
        var center = circleSize / 2;
        var viewBox = "0 0 " + circleSize + " " + circleSize;
        var radius = (circleSize / 2) - (8 / 2);
        var circumference = 2 * Math.PI * radius;
        var valueStyle = {
            strokeDashoffset: this.calculateCircleRatio(value, circumference),
            strokeDasharray: circumference
        };
        return (React.createElement("svg", { className: classes, width: circleSize, height: circleSize, viewBox: viewBox },
            React.createElement("circle", { className: theme.meter, cx: center, cy: center, r: radius, strokeWidth: strokeWidth }),
            React.createElement("circle", { className: theme.value, cx: center, cy: center, r: radius, strokeWidth: strokeWidth, style: valueStyle }),
            React.createElement("text", { className: theme.label, textAnchor: "middle", alignmentBaseline: "central", x: "50%", y: "50%" },
                value,
                "%")));
    };
    ProgressBar.prototype.renderLinear = function () {
        var _a, _b;
        var _c = this.props, children = _c.children, className = _c.className, theme = _c.theme, min = _c.min, max = _c.max, value = _c.value, circle = _c.circle, vertical = _c.vertical, animated = _c.animated, orange = _c.orange, green = _c.green, red = _c.red, yellow = _c.yellow, purple = _c.purple, deepPurple = _c.deepPurple, circleSize = _c.circleSize, others = tslib_1.__rest(_c, ["children", "className", "theme", "min", "max", "value", "circle", "vertical", "animated", "orange", "green", "red", "yellow", "purple", "deepPurple", "circleSize"]);
        var classes = classnames_1.default(theme.progress, className, (_a = {},
            _a[theme.vertical] = vertical,
            _a[theme.animated] = animated,
            _a[theme.orange] = orange,
            _a[theme.green] = green,
            _a[theme.red] = red,
            _a[theme.yellow] = yellow,
            _a[theme.purple] = purple,
            _a[theme.deepPurple] = deepPurple,
            _a));
        var fillStyles = (_b = {},
            _b[vertical ? "height" : "width"] = this.calculateLinearRatio(value) * 100 + "%",
            _b);
        return (React.createElement("div", tslib_1.__assign({ className: classes }, others),
            React.createElement("div", { className: theme.fill, style: fillStyles }),
            React.createElement("div", { className: theme.rail })));
    };
    ProgressBar.prototype.render = function () {
        var circle = this.props.circle;
        return circle
            ? this.renderCircle()
            : this.renderLinear();
    };
    ProgressBar.defaultProps = {
        min: 0,
        max: 100,
        value: 0,
        vertical: false,
        animated: true,
        circle: false,
        circleSize: 160
    };
    return ProgressBar;
}(React.Component));
exports.default = ProgressBar;
